import { Typography } from "@mui/material"

import IconBox from "../IconBox"
import { ContactItemProps } from "./props"
import BankIcon from "../BankIcon"
import { ItemContainer, ItemDescriptionContainer } from "../styled"

function getInitials(fullname: string) {
  const nameArray = fullname.split(" ")
  let initials = ""
  if (nameArray.length >= 1) {
    initials += nameArray[0].charAt(0).toUpperCase()
    if (nameArray.length >= 2) {
      initials += nameArray[1].charAt(0).toUpperCase()
    }
  }
  return initials
}

const ContactItem = ({
  desciption,
  name,
  bank,
  iconType,
  ...rest
}: ContactItemProps) => {
  const initials = getInitials(name)

  return (
    <ItemContainer {...rest}>
      <IconBox>
        {iconType === "contact" && (
          <Typography variant="h5Bold">{initials}</Typography>
        )}

        {iconType === "bank" && (
          <BankIcon logoUrl={bank.logoUrl} size={30} />
        )}
      </IconBox>

      <ItemDescriptionContainer>
        <Typography variant="h4">{name}</Typography>

        {desciption && (
          <Typography variant="h6" sx={{ fontWeight: 400 }}>
            {desciption}
          </Typography>
        )}
      </ItemDescriptionContainer>
    </ItemContainer>
  )
}

export default ContactItem
